define(function (require) {
    const tpl = require('civicsViews/send_email/templates/t_cpv_email.hbs');
    const Radio = require('backbone.radio');
  	const Channel = Radio.channel('SendEmailChannel');

    //Reuse item view from send email
    const rowView = require('civicsViews/send_email/v_itv_email');

    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    const IpsModel = require('civicsBase/ipsModel');
    const ViewManager = require('civicsUtils/view_manager');

    return Marionette.CompositeView.extend({
        template: tpl,
        ui: {
            addEmailButton: '.add-email-button'
        },
        events: {
            'click @ui.addEmailButton': 'addEmailAddress'
        },
        childView: rowView,
        childViewContainer: '.send-email-items',
        childEvents: {
            'email-item:onEmailFieldChange': function (childView, state) {
                var self = this;
                // Check other views if email is still exists
                _.each(self.collection.models, function (model) {
                    var view = self.children.findByModel(model);
                    if (childView != view) {
                        // if the value returns false then it will break this loop
                        if (!view.isEmailFieldEmpty()) {
                            return false;
                        }
                    }
                });
            },
            'email-item:remove': 'removeEmailAddress',
        },
        childViewOptions: function (model, index) {
            return {
              index: index+1,
              allowEmptyData: this.allowEmptyData
            };
        },
        initialize: function (options) {
            this.config = options.config;
            this.portletName = options.portletName; // target portletName to find its corresponding labels
            this.collection = new IpsModelCollection(new IpsModel({
                id: 1,
                emailAddressCollection: [{
                    emailAddress: '',
                }],
                showDelete: false
            }));
            this.allowEmptyData = options.allowEmptyData;
            this.allowMultipleEmail = options.allowMultipleEmail;

            //Setup the Labels
            if (this.portletName && this.portletName.length > 0) {
                var localizationKey = this.portletName.toUpperCase();

                this.commonLabel = {
                    'box_title': i18n.t('CIVICS.' + localizationKey + '.EMAIL.BOX_TITLE'),
                    'emailAddress_toolTip': i18n.t('CIVICS.' + localizationKey + '.EMAIL.EMAIL_ADDRESS_TOOLTIP'),
                    'emailAddress_headerDesc': i18n.t('CIVICS.' + localizationKey + '.EMAIL.EMAIL_ADDRESS'),
                    'addEmail_buttonDesc': i18n.t('CIVICS.' + localizationKey + '.EMAIL.ADD_EMAIL'),
                    'emailRequired': i18n.t('CIVICS.'+localizationKey+'.SHARE_URL.EMAIL_REQUIRED')
                }
            }
        },
        onRender: function () {
            this.$el.rhythmCivicsTooltipInit();
            this.$el.rhythmThemeInitCivics();
            this.$el.rhythmThemeInit();
        },
        addEmailAddress: function () {
            /*If user is logged in, populate the first row.*/
            if (this.saveFormData(true)) {
                var collectionCurrentIndex = this.collection.models.length > 0 ?
                    this.collection.models[this.collection.models.length - 1].get('id') : 0;
                /*create temporary model for email address only, will attached it later on the emailModel during sendEmail*/
                var newEmailModel = new IpsModel({
                    id: collectionCurrentIndex + 1,
                    emailAddressCollection: [{
                        emailAddress: '',
                    }],
                    showDelete: true
                });

                this.collection.add(newEmailModel);
            }
        },
        removeEmailAddress: function (childView) {
            this.collection.remove(this.collection.get({ cid: childView.model.cid }));

            this.removeChildView(childView);
            childView.destroy();

        },
        saveFormData: function (emptyFieldsOk) {
            var self = this;
            var isValid = true;
            var hasNonEmptyField = false;

            _.each(self.collection.models, function (model) {
                var view = self.children.findByModel(model);

                if(!view.isEmailFieldEmpty()) {
                  hasNonEmptyField = true;;
                }

                var data = view.getData();

                if (data && data.isValid) {
                    model.emailAddressCollection = data.emailAddressCollection;
                } else {
                    isValid = false;
                }

            });

            if(emptyFieldsOk) {
              return isValid;
            } else {
              if(!hasNonEmptyField) {
                this.showEmptyError();
              }
              return hasNonEmptyField && isValid;
            }

            return isValid;
        },
        showEmptyError: function () {
          Channel.trigger('showEmptyError');
        },
        templateHelpers: function () {
            var self = this;
            return {
                box_title: self.commonLabel.box_title,
                emailAddress_toolTip: self.commonLabel.emailAddress_toolTip,
                emailAddress_headerDesc: self.commonLabel.emailAddress_headerDesc,
                addEmail_buttonDesc: self.commonLabel.addEmail_buttonDesc
            };
        }
    });
});
